import { Center } from 'styled-system/jsx';
import Button from '@/common/components/base/button/Button.tsx';
import CheckIcon from '@/common/assets/icons/tickIcon.svg?react';
import { token } from 'styled-system/tokens';
import useModal from '@/common/hooks/useModal.ts';
import { SharedActionProps } from '@/modules/FileList/components/fileDetailCardActions/FileListlAction.type.ts';
import AcceptFileModalSelector from '@/modules/FileList/components/modals/acceptFileModals/AcceptFileModalSelector.tsx';

export default ({ fileId }: SharedActionProps) => {
  const { open, closeModal, openModal } = useModal();
  return (
    <>
      <Center borderTop="1px solid {colors.gray-2}">
        <Button
          onClick={openModal}
          gap="5px"
          fullWidth
          variant="text"
          color="primary"
        >
          <CheckIcon stroke={token('colors.purple-2')} />
          قبول پرونده
        </Button>
      </Center>
      <AcceptFileModalSelector
        fileId={fileId}
        open={open}
        closeModal={closeModal}
      />
    </>
  );
};
